/* This is a generated file, do not edit it directly */
import * as Types from '@noah-labs/shared-schema-gql';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions } from 'react-query';
import { useAppSyncRequest } from '@noah-labs/fe-shared-data-access-shared';
export type SigningJwtQueryVariables = Types.Exact<{ [key: string]: never }>;

export type SigningJwtQuery = {
  __typename?: 'Query';
  signingJwt: { __typename?: 'JwtToken'; Token: string };
};

export const SigningJwtDocument = /*#__PURE__*/ `
    query signingJwt {
  signingJwt {
    Token
  }
}
    `;

export const useSigningJwtQuery = <TData = SigningJwtQuery, TError = unknown>(
  variables?: SigningJwtQueryVariables,
  options?: UseQueryOptions<SigningJwtQuery, TError, TData>,
) => {
  return useQuery<SigningJwtQuery, TError, TData>(
    variables === undefined ? ['signingJwt'] : ['signingJwt', variables],
    useAppSyncRequest<SigningJwtQuery, SigningJwtQueryVariables>(SigningJwtDocument).bind(
      null,
      variables,
    ),
    options,
  );
};

useSigningJwtQuery.getKey = (variables?: SigningJwtQueryVariables) =>
  variables === undefined ? ['signingJwt'] : ['signingJwt', variables];

export const useInfiniteSigningJwtQuery = <TData = SigningJwtQuery, TError = unknown>(
  variables?: SigningJwtQueryVariables,
  options?: UseInfiniteQueryOptions<SigningJwtQuery, TError, TData>,
) => {
  const query = useAppSyncRequest<SigningJwtQuery, SigningJwtQueryVariables>(SigningJwtDocument);
  return useInfiniteQuery<SigningJwtQuery, TError, TData>(
    variables === undefined ? ['signingJwt.infinite'] : ['signingJwt.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options,
  );
};

useInfiniteSigningJwtQuery.getKey = (variables?: SigningJwtQueryVariables) =>
  variables === undefined ? ['signingJwt.infinite'] : ['signingJwt.infinite', variables];
